import userResources from './user';
import customerResources from './customer';

export default { userResources, customerResources };
